import { useTranslation } from "react-i18next";
import { FileText, Image } from "lucide-react";
import { Button } from "components/common/Button";
import type { ViewerMode } from "./types";

interface ViewerModeToggleProps {
  viewerMode: ViewerMode;
  onViewerModeChange: (mode: ViewerMode) => void;
}

export const ViewerModeToggle = ({
  viewerMode,
  onViewerModeChange,
}: ViewerModeToggleProps) => {
  const { t } = useTranslation();

  const isPdfMode = viewerMode === "pdf";

  return (
    <div className="absolute top-2 right-2 z-10 flex rounded-lg overflow-hidden border border-gray-300 shadow-sm">
      <Button
        size="sm"
        variant={!isPdfMode ? "primary" : "default"}
        onClick={() => onViewerModeChange("image")}
        startAdornment={<Image size={14} />}
        className="rounded-none"
      >
        {t("smartSurveyor.reviewPage.viewerMode.lowResolution")}
      </Button>
      <Button
        size="sm"
        variant={isPdfMode ? "primary" : "default"}
        onClick={() => onViewerModeChange("pdf")}
        startAdornment={<FileText size={14} />}
        className="rounded-none"
      >
        {t("smartSurveyor.reviewPage.viewerMode.highResolution")}
      </Button>
    </div>
  );
};
